export const AccountEndpoints = {
    details: `/account/system/details`,
    uploadAvatar: '/file-manager/upload/image',
}
